import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Define the initial state
const initialState = {
    suppliers: [],
    loading: false,
    error: null,
};

// Define asynchronous actions using createAsyncThunk

// Fetch all suppliers
export const fetchSuppliers = createAsyncThunk('suppliers/fetchSuppliers', async (id) => {
    const response = await axios.get(`${API_URL}/suppliers/${id}`);
    return response.data;
});

// Create a new supplier
export const createSupplier = createAsyncThunk(
    "suppliers/createSupplier",
    async (supplierData) => {
        const formData = new FormData();

        // Append all supplier fields
        Object.keys(supplierData).forEach((key) => {
            if (key === "pan_image" && supplierData[key]) {
                formData.append(key, supplierData[key]); // Append file
            } else {
                formData.append(key, supplierData[key]);
            }
        });

        const response = await axios.post(`${API_URL}/suppliers`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    }
);


// Update an existing supplier
export const updateSupplier = createAsyncThunk(
    "suppliers/updateSupplier",
    async ({ id, supplierData }) => {
        const formData = new FormData();

        // Append all supplier fields
        Object.keys(supplierData).forEach((key) => {
            if (key === "pan_image" && supplierData[key]) {
                formData.append(key, supplierData[key]); // Append file
            } else {
                formData.append(key, supplierData[key]);
            }
        });

        const response = await axios.put(`${API_URL}/suppliers/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    }
);


// Delete a supplier
export const deleteSupplier = createAsyncThunk('suppliers/deleteSupplier', async (id) => {
    await axios.delete(`${API_URL}/suppliers/${id}`);
    return id;
});

// Create the supplierSlice
const supplierSlice = createSlice({
    name: 'suppliers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Handle fetchSuppliers actions
        builder
            .addCase(fetchSuppliers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchSuppliers.fulfilled, (state, action) => {
                console.log("Fetched Suppliers:", action.payload);  // Log the payload for debugging
                state.loading = false;
                state.suppliers = Array.isArray(action.payload) ? action.payload : [];
                state.error = null; // Clear error on successful fetch
            })
            .addCase(fetchSuppliers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                console.error("Error fetching suppliers:", action.error.message);  // Log error
            })

            // Handle createSupplier actions
            .addCase(createSupplier.pending, (state) => {
                state.loading = true;
            })
            .addCase(createSupplier.fulfilled, (state, action) => {
                state.loading = false;
                state.suppliers.push(action.payload);
                state.error = null; // Clear error on successful creation
            })
            .addCase(createSupplier.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                console.error("Error creating supplier:", action.error.message);  // Log error
            })

            // Handle updateSupplier actions
            .addCase(updateSupplier.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateSupplier.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.suppliers.findIndex(supplier => supplier.id === action.payload.id);
                if (index !== -1) {
                    state.suppliers[index] = action.payload;
                }
                state.error = null; // Clear error on successful update
            })
            .addCase(updateSupplier.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                console.error("Error updating supplier:", action.error.message);  // Log error
            })

            // Handle deleteSupplier actions
            .addCase(deleteSupplier.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteSupplier.fulfilled, (state, action) => {
                state.loading = false;
                state.suppliers = state.suppliers.filter(supplier => supplier.id !== action.payload);
                state.error = null; // Clear error on successful delete
            })
            .addCase(deleteSupplier.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                console.error("Error deleting supplier:", action.error.message);  // Log error
            });
    },
});

export default supplierSlice.reducer;
